import * as React from "react";
import SoftBox from "../../components/SoftBox";
import curved9 from "../../assets/images/mainSiteBackground.jpg";
import CoverLayout from "../../components/CoverLayout";
import theme from "../../assets/theme";
import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider} from "@emotion/react";
import Cat404 from "assets/images/illustrations/cat_404.svg";

export default function ReturnsUnavailable() {

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <CoverLayout
                title={"Retouren noch nicht verfügbar"}
                color='primary'
                description={"Für diesen Shop ist die Retouren-Abwicklung noch nicht eingerichtet. Bitte wende dich an den Händler."}
                image={curved9}
            >
                <SoftBox>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <img src={Cat404}/>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            </CoverLayout>
        </ThemeProvider>)
}
